import { Controller } from "@hotwired/stimulus"

// Groups thousands with "." per the vi convention (1.500.000) while typing.
// Display-only: the :vnd_money attribute type parses the grouped string
// server-side, so this controller never has to clean the value before submit.
export default class extends Controller {
  connect() {
    this.format()
    // The layout refreshes with morph (see layouts/_head), so a save that
    // redirects back to the same URL (invoice builder) updates this input's
    // value in place — no reconnect, no input event. Reformat after each morph
    // or the server's bare "4000000" stays ungrouped.
    this.afterMorph = () => this.format()
    document.addEventListener("turbo:morph", this.afterMorph)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.afterMorph)
  }

  format() {
    const el = this.element
    const caret = el.selectionStart
    // Track the caret by how many digits sit to its left, not by its raw index:
    // inserting a "." shifts every index to its right.
    const digitsBeforeCaret =
      caret === null ? null : this.#digits(el.value.slice(0, caret)).length
    const digits = this.#digits(el.value)

    el.value = digits ? new Intl.NumberFormat("vi-VN").format(BigInt(digits)) : ""

    if (digitsBeforeCaret !== null) {
      const position = this.#caretFor(el.value, digitsBeforeCaret)
      el.setSelectionRange(position, position)
    }
  }

  #digits(value) {
    return value.replace(/\D/g, "")
  }

  #caretFor(formatted, digitCount) {
    if (digitCount === 0) return 0

    let seen = 0
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) seen++
      if (seen === digitCount) return i + 1
    }
    return formatted.length
  }
}
